import { get } from 'lodash';

const genders = {
  en: {
    0: 'None',
    1: 'Male',
    2: 'Female',
    3: 'Gender Neutral',
  },
  is: {
    0: 'Óskilgreint',
    1: 'Karl',
    2: 'Kona',
    3: 'Kynsegin',
  },
};

export default genders;

export const getGender = (lang, type) => get(genders, [lang, type]);



// WEBPACK FOOTER //
// ./src/utils/genders.js